import React, { MouseEventHandler, useEffect, useState } from 'react';

interface IProps {
  loading?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const SaveButton: React.FC<IProps> = ({ loading, onClick }) => {
  const [processing, setProcessing] = useState<boolean>(false);

  useEffect(() => {
    if (loading != null) {
      setProcessing(loading);
    }
  }, [loading]);

  return (
    <button
      disabled={processing}
      type="submit"
      className={`${
        processing ? 'cursor-not-allowed' : ''
      } ml-5 bg-primary border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light`}
      onClick={onClick}
    >
      {processing && (
        <svg
          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx={12}
            cy={12}
            r={10}
            stroke="currentColor"
            strokeWidth={4}
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {processing ? 'Saving...' : 'Save'}
    </button>
  );
};

export default SaveButton;
